export enum FfEndPoints {
    FINZY_FLEX = 'finzy-flex',
    INVESTMENT_INITIAL = 'investment-initial',
    PORTFOLIO = 'finzy-flex/portfolio',
    PORTFOLIO_CREATION = 'finzy-flex/portfolio-creation',
    PORTFOLIO_CREATION_SUCCESS = 'finzy-flex/portfolio/successful',
    PORTFOLIO_CREATION_FAILURE = 'finzy-flex/portfolio/failure',
    DASHBOARD = 'finzy-flex/dashboard',
    PREFERENCES = 'finzy-flex/preferences',
    LOANS = 'finzy-flex/loans',
    REPORTS = 'finzy-flex/reports',
    INTERESTCERTIFICATE='finzy-flex/interestCertificate',
    INITIATE_WITHDRAWAL = 'finzy-flex/initiate-withdrawal'
}